<select [(ngModel)]="selectedOptionId" (ngModelChange)="NotifyListeners()" class="form-select">
  <option *ngIf="needSelect"  value="0">Select an option</option>
  <option *ngFor="let option of options" [value]="option.id" [innerHTML]="option.label"></option>
</select>
